module.exports = __webpack_public_path__ + "static/media/_Alex_PRO_NEW.f24f07ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_Alex_PRO_NEW.png
// module id = 102
// module chunks = 0